<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.04335 7.83218H1.13086L1.85013 2H9.12861L9.04335 7.83218Z"
      fill="#8B90A4"
    />
    <path d="M8.90877 16.995H0L0.902528 9.67578H9.01578L8.90877 16.995Z" fill="#8B90A4" />
    <path
      d="M15.0629 5.80337C15.7568 5.80389 16.4377 5.99289 17.0326 6.35016C17.6276 6.70744 18.1144 7.21959 18.441 7.83193H19.082L18.3627 2H11.084L11.1695 7.83193H11.685C12.0115 7.21959 12.4983 6.70744 13.0932 6.35016C13.6881 5.99288 14.3689 5.80389 15.0629 5.80337Z"
      fill="#8B90A4"
    />
    <path
      d="M19.0976 9.69922H18.8906C18.8621 10.5715 18.2906 11.8478 17.1463 13.5973C16.311 14.8741 15.489 15.9059 15.4545 15.9492L15.0637 16.4384L14.673 15.9492C14.6385 15.9059 13.8167 14.8741 12.9812 13.5973C11.8367 11.8473 11.2654 10.5722 11.2369 9.69922H10.9844L11.0914 17.0182H20.0002L19.0976 9.69922Z"
      fill="#8B90A4"
    />
    <path
      d="M15.0644 6.30273C14.1818 6.30273 13.3352 6.65337 12.7111 7.27751C12.087 7.90165 11.7363 8.74817 11.7363 9.63084C11.7363 11.4691 15.0644 15.6368 15.0644 15.6368C15.0644 15.6368 18.3928 11.4691 18.3928 9.63084C18.3927 8.74815 18.042 7.90163 17.4178 7.2775C16.7937 6.65336 15.9471 6.30273 15.0644 6.30273ZM15.0644 10.9589C14.782 10.9589 14.5059 10.8751 14.2711 10.7182C14.0362 10.5613 13.8532 10.3383 13.7451 10.0773C13.637 9.81638 13.6087 9.52925 13.6638 9.25224C13.7189 8.97522 13.8549 8.72077 14.0547 8.52105C14.2544 8.32134 14.5088 8.18533 14.7858 8.13023C15.0628 8.07513 15.35 8.10341 15.6109 8.21149C15.8719 8.31958 16.0949 8.50261 16.2518 8.73745C16.4087 8.9723 16.4925 9.24839 16.4925 9.53083C16.4923 9.90951 16.3418 10.2726 16.074 10.5404C15.8063 10.8081 15.4431 10.9586 15.0644 10.9586V10.9589Z"
      fill="#8B90A4"
    />
  </svg>
</template>
